<template> 
    <v-dialog v-model="show" persistent fullscreen content-class="loading-dialog">
        <v-container fill-height>
        <v-layout row justify-center align-center>
            <v-progress-circular indeterminate :size="120" :width="15" color="primary">
                <img width="60" height="60" src="https://pbs.twimg.com/profile_images/634720991588020225/Gtl85bxs_400x400.jpg">
            </v-progress-circular>
        </v-layout>
        </v-container>
    </v-dialog>
</template>

<script>
export default {
  name: 'Loading',
  components: {},
  props: {
      show : Boolean
  },
  data: () => ({ }),
  watch: {},
  mounted() {
    setTimeout(() => {
      this.$radio.$on('showprogress', (showProgress)=>{
        this.show = showProgress;          
      });

    }, 0);
  }, 
  computed: {},
  methods: {}
}
</script>
<style scoped>
    .loading-dialog {
        background-color: #303030; 
    }   
</style>